import { render, staticRenderFns } from "./InstructionsInfo.vue?vue&type=template&id=50e4aae2&scoped=true"
import script from "./InstructionsInfo.vue?vue&type=script&lang=js"
export * from "./InstructionsInfo.vue?vue&type=script&lang=js"
import style0 from "./InstructionsInfo.vue?vue&type=style&index=0&id=50e4aae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4aae2",
  null
  
)

export default component.exports